export default __webpack_public_path__ + "images/9Y.02f0dc5.png";